module.exports = __webpack_public_path__ + "img/mockup-desktop-medici.9391c092.png";